import { CardBody } from 'components';
import { Price, Product } from '../types/Add-subscription.types';
import './AddonGroup.css';
import AddonItem from './AddonItem';

interface Addon {
  product: Product;
  price: Price;
}

interface AddonGroupProps {
  period: 'Anual' | 'Mensual';
  products: Product[];
  counts: Record<number, number>;
  addons: Addon[];
  selectedAddons: Record<number, boolean>;
  onToggle: (priceId: number) => void;
  getAdvantages: (product: Product, price: Price) => { name: string }[];
}

const AddonGroup = ({
  getAdvantages,
  period,
  counts,
  products,
  addons,
  selectedAddons,
  onToggle,
}: AddonGroupProps) => {
  const calculateAddonQuantity = (addonPrice: Price) => {
    return Object.entries(counts).reduce((total, [priceId, count]) => {
      const price = products
        .flatMap((p) => p.prices)
        .find((p) => p.id === Number(priceId));
      if (
        price &&
        price.product_type_id.name === addonPrice.product_type_id.name &&
        price.periocity_id.name === period
      ) {
        return total + count;
      }
      return total;
    }, 0);
  };

  return (
    <CardBody>
      <header className="addon-group__header">
        <h2 className="addon-group__title">BENEFICIOS ADICIONALES</h2>
        <p className="addon-group__description">
          Selecciona los beneficios adicionales que deseas añadir a tu plan
        </p>
      </header>
      <div className="addon-group__content">
        {addons.map(({ product, price }) => {
          const quantity = calculateAddonQuantity(price);
          return (
            <AddonItem
              getAdvantages={getAdvantages}
              key={price.id}
              product={product}
              price={price}
              quantity={quantity}
              isSelected={selectedAddons[price.id] || false}
              onToggle={() => onToggle(price.id)}
            />
          );
        })}
      </div>
    </CardBody>
  );
};

export default AddonGroup;
